export * from 'server/models/UserPermissionsResponse';


// WEBPACK FOOTER //
// ./data/models/UserPermissionsResponse.ts